import borders from './borders'
import colors from './colors'
import radius from './radius'
import shadows from './shadows'
import spacing from './spacing'
import iconsSize from './icons-size'
import {DeepPartial, SemanticsObject} from '../types/semantics.types'

const semanticOverrides: DeepPartial<SemanticsObject> = {
    colors: {
        text: {
            primary: colors['brand-primary'][100],
            tertiary: colors['brand-primary'][60],
        },
        background: {
            brand: colors['brand-primary'][100],
            'light-blue': colors['brand-primary'][60],
        },
    },
}

export {borders, colors, radius, shadows, spacing, iconsSize, semanticOverrides}
